import { addLatex, MATH_RENDER_ENGINE_BACKOFFICE } from 'app/config/configLatex';

export function initializeLatex() {
  window.mathRenderEngineFroalaV3 = MATH_RENDER_ENGINE_BACKOFFICE;
  addLatex(MATH_RENDER_ENGINE_BACKOFFICE);
}
